// src/store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import alarmReducer from "./slices/amsSlice";
import sensorGroupReducer from "./slices/sensorGroupSlice";
import renamedSensorsReducer from "./slices/renamedSensorsSlice";
import tagsReducer from "./slices/tagsSlice";
import sensorLimitsReducer from "./slices/sensorLimitsSlice";
import liveDataReducer from "./slices/liveDataSlice";
import appConfigReducer from "./slices/appConfig";
import sensorMultiplierReducer from "./slices/sensorMultiplierSlicer";
import reloadReducer from "./slices/reloadSlice";
import userReducer, { clearUserData } from "./slices/usersSlice";
import settingSliceReducer from "./slices/settingSlice";
import permissionReducer from "./slices/permissionSlice";
import chartReducer from "./slices/chartSlice";
import playbackReducer from "./slices/playBackSlice";
import operationPdfReducer from "./slices/operationPdfSlice";

const appReducer = combineReducers({
  alarm: alarmReducer,
  sensorGroup: sensorGroupReducer,
  renamedSensors: renamedSensorsReducer,
  tags: tagsReducer,
  sensorLimits: sensorLimitsReducer,
  liveData: liveDataReducer,
  appConfig: appConfigReducer,
  sensorMultiplier: sensorMultiplierReducer,
  reload: reloadReducer,
  user: userReducer,
  settings: settingSliceReducer,
  permission: permissionReducer,
  chart: chartReducer,
  playback: playbackReducer,
  operationPdf: operationPdfReducer,
});

const rootReducer = (state, action) => {
  if (action.type === clearUserData.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
